import { HomeScreen } from '../features/home/HomeScreen';

export const HomePage = () => {
  return <HomeScreen />;
};
